module.exports = __webpack_public_path__ + "static/media/testen.e718d156.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/testen.svg
// module id = 782
// module chunks = 0